import React, { useState } from "react";

const SurveyQuestionModal = ({
  isOpen,
  onClose = () => {},
  survey = null
}) => {
  const [selectedUser, setSelectedUser] = useState(null);

  if (!isOpen || !survey) return null;

  const handleUserChange = (event) => {
    const userId = event.target.value;
    if (userId === "") {
      setSelectedUser(null);
    } else {
      const user = survey.responses.find(response => response.id === userId);
      setSelectedUser(user);
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-11/12 max-h-[90vh] overflow-y-auto rounded-lg shadow-lg p-6">
        <div className="flex justify-between items-center mb-4">
          <div>
            <h2 className="text-2xl font-semibold">
              {survey.surveyName}
            </h2>
            <p className="text-gray-600 mt-1">{survey.objective}</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl"
          >
            ×
          </button>
        </div>

        {survey.responses && survey.responses.length > 0 ? (
          <div className="space-y-6">
            {/* Users Dropdown */}
            <div className="border-b pb-4">
              <h3 className="text-lg font-semibold mb-3">Survey Responses</h3>
              <div className="flex items-center space-x-4">
                <select
                  id="userSelect"
                  value={selectedUser?.id || ""}
                  onChange={handleUserChange}
                  className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#241763] focus:border-[#241763] min-w-[250px]"
                >
                  <option value="">-- Select a respondent --</option>
                  {survey.responses.map((response) => (
                    <option key={response.id} value={response.id}>
                      {response.fullName}
                    </option>
                  ))}
                </select>
                <span className="text-sm text-gray-500">
                  ({survey.responses.length} responses)
                </span>
              </div>
            </div>

            {/* Selected User's Responses */}
            {selectedUser && (
              <div className="border-t pt-4">
                <h4 className="text-lg font-semibold mb-4">
                  Responses from: {selectedUser.fullName}
                </h4>
                
                {selectedUser.surveyDetail?.questions?.map((question, qIndex) => (
                  <div key={question.id} className="mb-6 border border-gray-200 p-4 rounded-lg">
                    <div className="mb-3">
                      <label className="block font-medium text-gray-700">
                        Question {qIndex + 1}
                      </label>
                      <p className="text-gray-900 mt-1">
                        {question.questionText}
                      </p>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                      {question.options?.map((option, oIndex) => (
                        <div 
                          key={oIndex} 
                          className={`border border-gray-200 p-3 rounded-lg ${
                            selectedUser.answers?.some(answer => 
                              answer.questionId === question.id && answer.selectedOption === option
                            ) 
                              ? 'bg-[#241763] text-white border-[#241763]' 
                              : 'bg-gray-50 text-gray-700'
                          }`}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Survey Questions Overview */}
            {!selectedUser && survey.responses.length > 0 && (
              <div className="border-t pt-4">
                <h4 className="text-lg font-semibold mb-4">Survey Questions Overview</h4>
                {survey.responses[0]?.surveyDetail?.questions?.map((question, qIndex) => (
                  <div key={question.id} className="mb-4 border border-gray-200 p-4 rounded-lg">
                    <div className="mb-2">
                      <label className="block font-medium text-gray-700">
                        Question {qIndex + 1}
                      </label>
                      <p className="text-gray-900 mt-1">
                        {question.questionText}
                      </p>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                      {question.options?.map((option, oIndex) => (
                        <div 
                          key={oIndex} 
                          className="border border-gray-200 p-2 rounded bg-gray-50 text-gray-700"
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ) : (
          <div className="text-center py-8">
            <p className="text-gray-500">No responses found for this survey.</p>
          </div>
        )}

        <div className="flex justify-end space-x-4 mt-6 pt-4 border-t">
          <button
            type="button"
            onClick={onClose}
            className="bg-gray-400 text-white px-6 py-2 rounded hover:bg-gray-500"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SurveyQuestionModal;
